import React from 'react';

const People = () => {
    return (
        <div className="page">
            <div className="page-header">
                <h1>People</h1>
            </div>
            <div className="card">
                <h2>People Dashboard</h2>
                <p style={{ color: 'var(--text-muted)' }}>Coming soon...</p>
            </div>
        </div>
    );
};

export default People;